export const removeAccents = (term : string) => {
    return term
    .normalize('NFD') 
    .replace(/[\u0300-\u036f]/g, '');
}